/**
 * Project-owner allowlist for developer-only UI (e.g. the live payment
 * verification panel on /account).
 *
 * Sourced from `VITE_OWNER_EMAILS` (comma-separated, lowercased). The
 * `FALLBACK_OWNERS` array can be populated with hardcoded emails when an
 * env var isn't practical. Empty by default — confirm your email and add
 * it here (or set the env var) to unlock the panel.
 *
 * NOTE: This is UI gating, not a security boundary. The underlying
 * `create-checkout` edge function is intentionally callable by anyone —
 * this just hides the dev/QA tool that triggers it from end users.
 */
const FALLBACK_OWNERS: string[] = [
  "andrew.painten@gmail.com",
];

export const isProjectOwner = (email: string | null | undefined): boolean => {
  if (!email) return false;
  const raw = (import.meta.env.VITE_OWNER_EMAILS as string | undefined) || "";
  const fromEnv = raw
    .split(",")
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);
  const allow = fromEnv.length ? fromEnv : FALLBACK_OWNERS;
  return allow.includes(email.toLowerCase().trim());
};
